import { useFormik } from 'formik';
import { ParamFunctionariesSwitchboard } from '../../../../../shared/types/param';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { asyncGetCities } from '../../../../../services/location.service';

export const useFunctionariesSwitchboardFilters = (
    onFilter?: (data: ParamFunctionariesSwitchboard) => void
) => {
    const [areaOptions, setAreaOptions] = useState<ISelect[]>([]);
    const [positionOptions, setPositionOptions] = useState<ISelect[]>([]);
    const [cityOptions, setCityOptions] = useState<ISelect[]>([]);

    const onSubmit = (data: ParamFunctionariesSwitchboard) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues: {
            nameFunctionary: '',
            emailFunctionary: '',
            areaFunctionary: '',
            positionFunctionary: '',
            cityId: '',
            active: true,
        },
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.FUNCTIONARIES_SWITCHBOARD_AREA).then((items) =>
            setAreaOptions(items)
        );

        asyncGetParams(ParamEnum.FUNCTIONARIES_SWITCHBOARD_POSITION).then(
            (items) => setPositionOptions(items)
        );
        asyncGetCities().then((cities) => setCityOptions(cities));
    }, []);

    return { formik, areaOptions, positionOptions, cityOptions };
};
